import React from 'react';
import { Box, Heading as TypographyHeading } from '@hover/blueprint';
import Heading from './Heading';
import Hero from './Hero';
import ShowCasePartners from '../common/ShowcasePartners';
import { PARTNERS_MEET_MORE_COMPANIES } from '../../../constants/partners';

export const FeaturedPartners: typeof Box = props => (
  <Box d="block" w="100%" mt="100px" {...props}>
    <Heading />
    <Hero />
    <TypographyHeading
      mt={{ base: '80px', desktop: '100px' }}
      size={300}
      sx={{ mb: 4 }}
      textAlign="center"
    >
      Meet more of the companies we partner with.
    </TypographyHeading>
    <ShowCasePartners partners={PARTNERS_MEET_MORE_COMPANIES} />
  </Box>
);
